import { render, staticRenderFns } from "./taskFolder.vue?vue&type=template&id=4acd5cdf&scoped=true&"
import script from "./taskFolder.vue?vue&type=script&lang=js&"
export * from "./taskFolder.vue?vue&type=script&lang=js&"
import style0 from "./taskFolder.vue?vue&type=style&index=0&id=4acd5cdf&scoped=true&lang=less&"
import style1 from "./taskFolder.vue?vue&type=style&index=1&id=4acd5cdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd5cdf",
  null
  
)

export default component.exports